import { render, staticRenderFns } from "./DialogDetalhesDoServico.vue?vue&type=template&id=3a63b9fc"
import script from "./DialogDetalhesDoServico.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDetalhesDoServico.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports